import React from 'react';
import { Stack, InputLabel, MenuItem } from '@compass/core';
import { FormControl, Select, SelectChangeEvent } from '@mui/material';
import { LkStudentDisplayFilterId } from 'generated/openApi';
import { useParticipantsData } from '../contexts/ParticipantsDataContext';

export const ParticipantsFilterControls = () => {
    const { 
        filter, 
        updateFilter, 
        activeSchoolYear,
        programs, 
        schoolYears, 
        programsLoading,
        displayFilters,
    } = useParticipantsData();

    const showProgramFilter = displayFilters?.some(x => x.id === LkStudentDisplayFilterId.Program);

    // show activeSchoolYear when filter is null (initial load)
    const displayedYear = filter.schoolYear ?? activeSchoolYear ?? '';

    const handleYearChange = (event: SelectChangeEvent<number | string>) => {
        updateFilter({ schoolYear: Number(event.target.value) });
    };

    const handleProgramChange = (event: SelectChangeEvent<string>) => {
        const value = event.target.value;
        updateFilter({ programId: value ? Number(value) : undefined });
    };

    // Don't render until we have schoolYears from backend
    if (schoolYears.length === 0) {
        return null;
    }

    return (
        <Stack direction="row" spacing="sm" sx={{ mb: 2 }}>
            <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel id="participants-school-year-label">School Year</InputLabel>
                <Select
                    labelId="participants-school-year-label"
                    value={displayedYear}
                    label="School Year"
                    onChange={handleYearChange}
                >
                    {schoolYears.map(year => (
                        <MenuItem key={year} value={year}>
                            {`${year}-${year + 1}`}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {showProgramFilter && (
                <FormControl size="small" sx={{ minWidth: 120 }}>
                    <InputLabel id="participants-program-label">Program</InputLabel>
                    <Select
                        labelId="participants-program-label"
                        value={filter.programId?.toString() ?? ''}
                        label="Program"
                        onChange={handleProgramChange}
                        disabled={programsLoading}
                    >
                        <MenuItem value="">All Programs</MenuItem>
                        {programs.map(prog => (
                            <MenuItem key={prog.id} value={prog.id}>
                                {prog.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        </Stack>
    );
};